import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSync, faImages } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import NewBanner from '../NewBanner/NewBanner';

export default function BannerData() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);

  // Toasts con clases globales
  const [toasts, setToasts] = useState([]);
  const showToast = (message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3800);
  };

  useEffect(() => {
    cargarBanners();
  }, []);

  const cargarBanners = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${baseURL}/bannersGet.php`, { method: 'GET' });
      const data = await res.json();
      setBanners(data.banner || []);
    } catch (e) {
      console.error('Error al cargar banners:', e);
      showToast('Error al cargar banners', 'error');
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    cargarBanners();
    showToast('Lista actualizada', 'info');
  };

  const eliminarBanner = (idBanner) => {
    Swal.fire({
      title: '¿Eliminar banner?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await fetch(`${baseURL}/bannerDelete.php?idBanner=${idBanner}`, { method: 'DELETE' });
          const data = await res.json();
          if (data?.mensaje) {
            showToast('Banner eliminado', 'success');
            cargarBanners();
          } else {
            showToast(data?.error || 'No se pudo eliminar', 'error');
          }
        } catch (e) {
          console.error('Error al eliminar banner:', e);
          showToast('Error de conexión al eliminar', 'error');
        }
      }
    });
  };

  return (
    <div>
      {/* Toasts globales */}
      {toasts.length > 0 && (
        <div className="product-toast-container">
          {toasts.map(t => (
            <div key={t.id} className={`product-toast ${t.type}`}>
              <div className="toast-icon">
                {t.type === 'success' && '✅'}
                {t.type === 'error' && '❌'}
                {t.type === 'warning' && '⚠️'}
                {t.type === 'info' && 'ℹ️'}
              </div>
              <div className="toast-content">
                <div className="toast-title">{t.message}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Header compacto con métricas y acción */}
      <div className="global-component-header" style={{ padding: '12px 16px' }}>
        <div className="flex-between">
          <div className="global-component-title">
            <FontAwesomeIcon icon={faImages} />
            Gestión de Banners
          </div>

          <div className="flex-center" style={{ gap: '12px' }}>
            <div className="global-stat-card compact" style={{ marginLeft: '10px' }}>
              <span className="global-stat-number">{banners.length}</span>
              <span className="global-stat-label">Banners</span>
            </div>
            <button
              onClick={refreshData}
              className="btn-product-secondary compact flex-center"
              title="Actualizar"
            >
              <FontAwesomeIcon icon={faSync} />
            </button>
          </div>
        </div>
      </div>

      {/* Crear nuevo banner */}
      <div className="mb-24">
        <NewBanner onCreated={cargarBanners} />
      </div>

      {/* Grid de banners */}
      <div className="product-section-card">
        <div className="product-section-header">
          <div className="product-section-title">
            <FontAwesomeIcon icon={faImages} />
            Banners activos
          </div>
        </div>

        <div className="product-section-content">
          {loading ? (
            <div className="global-loading-state">
              <FontAwesomeIcon icon={faSync} size="2x" />
              <div>Cargando banners...</div>
            </div>
          ) : banners.length > 0 ? (
            <div className="product-images-grid">
              {banners.map((item, index) => (
                <div
                  key={item.idBanner || index}
                  className="product-image-upload-area has-image"
                  style={{ position: 'relative' }}
                >
                  <img
                    src={item.imagen}
                    alt={`banner-${item.idBanner}`}
                    className="product-image-preview"
                  />
                  <button
                    className="product-image-remove"
                    onClick={() => eliminarBanner(item.idBanner)}
                    title="Eliminar"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="global-empty-state">
              <FontAwesomeIcon icon={faImages} size="3x" />
              <div className="global-empty-title">No hay banners</div>
              <div className="global-empty-description">
                Crea tu primer banner con el botón “Agregar”.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
